/* Reya · The Reya edit — card image swiping + dots, tap-to-quick-view on touch, carousel counter/progress.
   Arrows are wired by reya-core.js ([data-rr-scroller-wrap]); tabs by rr-tabs.js; add to bag by Dawn product-form. */
(() => {
  if (window.__rrEdit) return;
  window.__rrEdit = true;
  const touch = window.matchMedia('(hover: none)');
  const pad = (n) => (n < 10 ? '0' : '') + n;

  const initGallery = (slides) => {
    if (slides.dataset.rrInit) return;
    slides.dataset.rrInit = '1';
    const card = slides.closest('.rr-edit__card');
    const dots = card ? [...card.querySelectorAll('[data-rr-edit-dot]')] : [];
    const go = (i, behavior = 'smooth') => {
      const s = slides.children[i];
      if (s) slides.scrollTo({ left: s.offsetLeft, behavior });
    };
    const sync = () => {
      const i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
      dots.forEach((d, k) => (k === i ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current')));
    };
    slides.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    dots.forEach((d) => d.addEventListener('click', () => go(+d.dataset.rrEditDot)));

    // Desktop: hovering the card brings forward the second image.
    if (card && slides.children.length > 1) {
      card.addEventListener('mouseenter', () => !touch.matches && go(1));
      card.addEventListener('mouseleave', () => !touch.matches && go(0));
    }
    // Touch: tapping the image opens Quick view (the link stays for crawlers / no-JS).
    slides.addEventListener('click', (e) => {
      if (!touch.matches || !card) return;
      const qv = card.querySelector('[data-rr-edit-qv]');
      if (!qv) return;
      e.preventDefault();
      qv.click();
    });
  };

  const initCarousel = (wrap) => {
    if (wrap.dataset.rrEditInit) return;
    wrap.dataset.rrEditInit = '1';
    const track = wrap.querySelector('[data-rr-scroller]');
    const cur = wrap.querySelector('[data-rr-edit-current]');
    const bar = wrap.querySelector('[data-rr-edit-progress]');
    if (!track) return;
    const update = () => {
      const items = track.children;
      if (!items.length) return;
      const w = items[0].getBoundingClientRect().width || 1;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const max = track.scrollWidth - track.clientWidth;
      let i = Math.round(track.scrollLeft / (w + gap)) + 1;
      if (max > 0 && track.scrollLeft >= max - 2) i = items.length;
      if (cur) cur.textContent = pad(Math.min(i, items.length));
      const p = track.scrollWidth ? (track.scrollLeft + track.clientWidth) / track.scrollWidth : 1;
      if (bar) bar.style.transform = `scaleX(${Math.min(1, Math.max(0.08, p))})`;
    };
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-rr-edit-slides]').forEach(initGallery);
    root.querySelectorAll('[data-rr-edit-carousel]').forEach(initCarousel);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
